export enum FoldingMode {
  Unfolded = 'unfolded',
  Folded = 'folded',
}
